module.exports = __webpack_public_path__ + "static/media/logo-new-style.e9a55b96.svg";